import type { PlanCreationStep } from '../../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { PLAN_CREATION_STEPS } from '../../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { CreatePlanPageTabs } from '../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanPageTabs/CreatePlanPageTabs';
import { PlanSettings } from '../../../plans/CreatePlanPage/create-plan-page-components/PlanSettings';

export const REVISE_FOR_RENEWAL_STEPS_CONTENT: Record<PlanCreationStep, React.ReactElement> = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: <CreatePlanPageTabs />,
  [PLAN_CREATION_STEPS.settings]: <PlanSettings />,
};

export const REVISE_CURRENT_STEPS_CONTENT: Record<PlanCreationStep, React.ReactElement> = {
  [PLAN_CREATION_STEPS.pricingAndProducts]: <CreatePlanPageTabs />,
};
